import { colors } from './colors';

export const contractorStatus = {
    24: colors.green,
    25: colors.yellow,
};
